import { mockBuilder } from '../../utils/builderHelper.es.js';
import '../../enums/CoverSongOptionsEnum.es.js';
import { ReleaseLiveStatus } from './ReleaseLiveStatus.es.js';

/** @module Mocks */ /** typedoc */
function aReleaseLiveStatus() {
    return mockBuilder(new ReleaseLiveStatus([], []));
}

export { aReleaseLiveStatus };
